import { useCallback } from 'react';

import { isDocumentProjectType } from 'src/data/project';
import { useErrorHandler } from 'src/services';
import { useProjectActions } from 'src/store';
import { useProjectSettingsPopup } from 'src/views/ProjectSettingsPopup';

export const useRenameProject = () => {
  const openProjectSettingsPopup = useProjectSettingsPopup();
  const handleError = useErrorHandler();
  const projectActions = useProjectActions();

  return useCallback(
    (project) => {
      openProjectSettingsPopup({
        name: project.name,
        isDocument: isDocumentProjectType(project.type),
        displayName: true,
        displayMoveToFolder: false,
        onConfirm: ({ name }) => {
          projectActions.renameProject({ id: project.id, name }).catch((error) => {
            handleError(error);
          });
        },
      });
    },
    [openProjectSettingsPopup, projectActions, handleError]
  );
};
